import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { LcpService } from 'src/app/services/lcp/lcp.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'route-fortify-v2-callback',
  templateUrl: './fortify-v2-callback.component.html',
  styleUrls: ['./fortify-v2-callback.component.scss']
})
export class FortifyV2CallbackComponent implements OnInit {
  token: string;
  identity: any;
  email: string;
  username: string;
  validated: boolean = true;
  isLogout: boolean = false;
  subscription! : Subscription;
  statusDescription: string = 'You will be redirected in a moment...';
  errorDescription: string = '';

  constructor(
    private auth: AuthService,
    private storage: StorageService,
    private lcpService: LcpService,
    private router: Router
  ) { 
    //
    //  1. Check for Logout and Change in storage.
    //
    if (this.storage.isExisted('logout-fortify-v2')) {
      this.isLogout = this.storage.getItem('logout-fortify-v2');
    }
    //
    //  2. Subscribe to Auth Service token$.
    // 
    this.subscription = 
    this.auth.getToken$()
    .subscribe( res => {
      if (res != (undefined || null )) {
        //
        // Handle the logout when discovery occurs.
        if (this.isLogout) {
          this.storage.remove('logout-fortify-v2');
          this.auth.logout();
          return;
        }
        //
        // Token received ready to call api/login now.
        console.log('this.auth.getToken$() : ' + res)
        this.token = res;
        this.setPageOptions();
        this.validateToken();
      }
    })
    //
    //  3. check for existing AccessToken, if not discover the doc for the token.
    //  
    let accessToken = this.auth.getAccessToken();
    if ( accessToken != null ) {
      this.token = accessToken;
      this.setPageOptions();
      this.validateToken();     
    } 
    if ( accessToken == null ) {
      this.identity = this.auth.discoverCode();
    }


  }

  ngOnInit() {
    document.body.style.paddingTop = "0px"; // unit measured in Edge.
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setPageOptions(): void {
    this.identity = this.auth.getIdentityClaims();
    console.log(this.identity);
    this.email = this.identity['email'];
    console.log(this.email);
    this.username = this.identity['name'];
    console.log(this.username);
    this.statusDescription = 'looking into your account(s)...';
    this.auth.findWaldo(this.username).subscribe( res => {
      console.warn('this.auth.findWaldo('+ this.username + ') : ' + JSON.stringify(res))
    })
  }

  validateToken() {
    let token = this.auth.getAccessToken();
    console.log('token : ' + token); // if null we will need a retry/log back in policy
    this.validated = true;
    this.lcpService.validateToken(token)
    .subscribe(
      res => {
        console.log('validateUserName : ' + JSON.stringify(res));

        if (res.Success == true) {
          this.validated = true;
          this.router.navigateByUrl('/auth/accounts');
        }

        if (res.Success == false) {
          setInterval(() => {
            this.validated = false;
            this.errorDescription = res.Message;
          }, 2000)
        }

      },
      error => {
        console.log('validateUserName error: ' + JSON.stringify(error));
        this.validated = false;
        this.errorDescription = error.message;
      });
  }

  logout() {
    this.router.navigateByUrl('/auth/logout');
  }

  goBack() {
    window.location.href = environment.userPortal;
  }


}
